import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import SimpleMDE from 'react-simplemde-editor'

import MarkdownLabel from '../../../mini/MarkdownLabel'

import { editReviewComment } from '../../../../actions/review'
import { simpleMDEOptions } from '../../../../utils/index'
import { save, submit, cancelReview } from '../../../../utils/messages'
import { messages } from '../../../../utils/messages/placeholder'

class Comment extends Component {
  constructor(props) {
    super(props)

    this.state = {
      comment: this.props.review ? this.props.review.comment : '',
      isEditing: this.props.isEditing,
      isDirty: false
    }

    this.handleCommentChangeBound = this.handleCommentChange.bind(this)
    this.onSaveCommentClickBound = this.onSaveCommentClick.bind(this)
    this.handleCompleteBound = this.handleComplete.bind(this)
    this.handleCancelBound = this.handleCancel.bind(this)
  }

  render() {
    const { review } = this.props
    const { intl } = this.context
    const comment = review ? review.comment : ''

    const options = Object.assign({}, simpleMDEOptions)
    options.initialValue = comment
    options.autofocus = true
    options.placeholder = intl.formatMessage(messages.typeYourComment)

    return (
      <div className="shadow">
        {!this.state.isEditing && (
          <MarkdownLabel
            additionalCssClasses="comment-body"
            value={comment.body}
          />
        )}
        {this.state.isEditing && (
          <div className="edit-comment-area">
            <div className="active-review-comment">
              {this.state.isDirty ? (
                <div
                  id="saveCommentButton"
                  className="button active"
                  onClick={this.onSaveCommentClickBound}
                >
                  {save}
                </div>
              ) : (
                <div
                  id="saveCommentButton"
                  className="button disabled"
                  disabled
                >
                  {save}
                </div>
              )}
              <SimpleMDE
                options={options}
                onChange={this.handleCommentChangeBound}
              />
              <div className="review-actions">
                <div
                  className={this.getDoneButtonStateClass(review)}
                  onClick={this.handleCompleteBound}
                >
                  {submit}
                </div>
                <div
                  className={'button cancel'}
                  onClick={this.handleCancelBound}
                >
                  {cancelReview}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  getDoneButtonStateClass(review) {
    var buttonClass = 'button done '
    if (review) {
      if (review.accepted === null) {
        buttonClass += 'disabled'
      } else if (review.accepted === false && !this.state.comment) {
        buttonClass += 'disabled'
      }
    }
    return buttonClass
  }

  handleCancel() {
    return this.props.handleCancel()
  }

  handleComplete(comment) {
    return this.props.handleComplete(this.state.comment)
  }

  onSaveCommentClick() {
    const { quest, review, dispatch } = this.props
    dispatch(
      editReviewComment(
        quest.id,
        quest.reviewing_compiled_quest.id,
        review.id,
        this.state.comment
      )
    )
    this.setState({ isDirty: false })
  }

  handleCommentChange(val) {
    const { review } = this.props
    if (val !== review.comment) {
      this.setState({
        isDirty: true,
        comment: val
      })
    }
    // Clicking on the md editor when editor is empty returns an empty string, which causes setState({isDirty: true})
    // This checks to see if editor and saved comment are empty, and if so, keeps isDirty state at false
    if (!val && !review.comment) {
      this.setState({
        isDirty: false
      })
    }
  }
}

Comment.propTypes = {
  dispatch: PropTypes.func,
  user: PropTypes.object,
  quest: PropTypes.object.isRequired,
  review: PropTypes.object,
  isEditing: PropTypes.bool,
  handleComplete: PropTypes.func,
  handleCancel: PropTypes.func
}

Comment.contextTypes = {
  intl: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  user: state.user.user,
  quest: state.quest.item
})

export default connect(mapStateToProps)(Comment)
export { Comment as CommentDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/components/quest/review/qualityreview/Comment.js